// extracted by mini-css-extract-plugin
export var modal = "_ar-0";